import React from 'react';
import { GridActionsCellItem, GridActionsCellItemProps } from '@mui/x-data-grid-pro';
import { TooltipCell } from './TooltipCell';
import { palette } from 'theme/palette';

type ActionCellProps = {
  label: string;
  icon: React.ReactElement;
  disabled?: boolean;
  disabledLabel?: string;
  isCurrentRowActive: boolean;
} & GridActionsCellItemProps;

export const ActionCell: React.FC<ActionCellProps> = ({
  label,
  icon,
  disabled = false,
  disabledLabel,
  isCurrentRowActive,
  ...props
}) => {
  return (
    <GridActionsCellItem
      icon={
        <TooltipCell title={label} disabledLabel={disabledLabel} disabled={disabled}>
          {icon}
        </TooltipCell>
      }
      {...props}
      disabled={disabled}
      label={label}
      material={{
        color: 'inherit',
        sx: {
          '&.Mui-disabled': { pointerEvents: 'all' },
          '&:not(.Mui-disabled)': {
            '& svg': { fill: isCurrentRowActive ? palette.text.primary : palette.text.secondary },
          },
        },
      }}
    />
  );
};
